module.exports = require('./helpers/bundle-url').getBundleURL('2hqst') + "logo-dark.eefe0b7f.svg";